import React from 'react'
import '../style/Footer.css'

function Footer() {
    return (
        <div className='footer'>
            <p>Copyright @ EDU 2021</p>
            
        </div>
    )
}

export default Footer
